import axios from 'Axios';
import { INITIAL_LOAD, DEMAND_DASHBOARD_DATA } from '../api/Routes';

function getInitDataStart() {
  return {
    type: 'GET_INIT_DATA_START',
  };
}

function getInitDataDone(data) {
  return {
    type: 'GET_INIT_DATA_DONE',
    users: data.users,
    projectUsages: data.usages,
  };
}
function getDemandDashboardDataStart() {
  return {
    type: 'GET_DEMAND_DASHBOARD_DATA_START',
  };
}

export function addDemandDashboardProject() {
  return {
    type: 'ADD_DEMAND_DASHBOARD_PROJECT',
  };
}

function getDemandDashboardDataDone(data) {
  return {
    type: 'GET_DEMAND_DASHBOARD_DATA_DONE',
    demandDashboardData: data,
  };
}

function initError(errorMessage) {
  return {
    type: 'INIT_ERROR',
    errorMessage,
  };
}
export const getInitData = () => {
  return function(dispatch) {
    dispatch(getInitDataStart());

    axios
      .get(INITIAL_LOAD)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(getInitDataDone(data));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(initError(errorMessage));
      });
  };
};
export const getDemandDashboardData = () => {
  return function(dispatch) {
    dispatch(getDemandDashboardDataStart());

    const dashboardLabels = {
      numberOfSearches: 'Searches created',
      numberOfProjects: 'Own projects',
      numberOfSharedProjects: 'Shared projects',
      averageNumberOfSlipsByTicket: 'Responses/search',
      outstandingActions: 'Outstanding actions',
    };

    axios
      .get(DEMAND_DASHBOARD_DATA)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        const dashboardData = Object.keys(data).map(key => {
          let title = dashboardLabels[key];
          return {
            key,
            title,
            count: data[key],
          };
        });
        dispatch(getDemandDashboardDataDone(dashboardData));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(initError(errorMessage));
      });
  };
};
